import { AxiosResponse } from 'axios';
import { Manufacturer } from 'domain/shared/Manufacturer';
import { getAppService } from './service.base';

const apiService = getAppService();

export interface ManufacturerResponse {
  rows: Manufacturer[];
  count: number;
}

export interface CreateManufacturerDto {
  manufacturerName: string;
  originalSourceName?: string;
  sWtg?: string;
  wtg?: string;
  gearbox?: string;
  generator?: string;
  country?: string;
  websiteLink?: string;
  remark?: string;
}

export const getManufacturers = async (offset: number, limit: number, search?: string, sort?: string): Promise<AxiosResponse<ManufacturerResponse>> => {
  const searchQuery = search ? `&search=${search}` : '';
  const sortQuery = sort ? `&sort=${sort}` : '';
  return apiService.withGet(`master-data/manufacturers?offset=${offset}&limit=${limit}${searchQuery}${sortQuery}`, 'Something went wrong while fetching manufacturers.');
};

export const getManufacturerById = async (id: number): Promise<AxiosResponse<Manufacturer>> => {
  return apiService.withGet(`master-data/manufacturers/${id}`, 'Something went wrong while fetching manufacturer.');
};

export const createManufacturer = async (manufacturer: CreateManufacturerDto): Promise<AxiosResponse<Manufacturer>> => {
  return apiService.withPost('master-data/manufacturers', manufacturer, 'Something went wrong while creating manufacturer.');
};

export const updateManufacturer = async (id: number, manufacturer: CreateManufacturerDto): Promise<AxiosResponse<Manufacturer>> => {
  return apiService.withPut(`master-data/manufacturers/${id}`, manufacturer, 'Something went wrong while updating manufacturer.');
};

export const deleteManufacturer = async (id: number): Promise<AxiosResponse<void>> => {
  return apiService.withDelete(`master-data/manufacturers/${id}`, 'Something went wrong while deleting manufacturer.');
};
